module.exports = __webpack_public_path__ + "img/header-ccc@2x.1b03669.jpg";